// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const sourcesCatalogClient = createTypedClient();
export const createSourcesCatalogClient = (config) => createTypedClient(config);
